import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';

const getRoleGroupByRole = role => {
    switch (role) {
        case ALL_USER_ROLES.L1_CSR:
        case ALL_USER_ROLES.L2_CSR:
        case ALL_USER_ROLES.SUPERVISOR:
        case ALL_USER_ROLES.L0_READONLY:
            return USER_GROUPS.CSR_GROUP;
        case ALL_USER_ROLES.AGENCY_MANAGER:
        case ALL_USER_ROLES.APPROVEDADMINSTAFFL1:
        case ALL_USER_ROLES.APPROVEDADMINSTAFFL2:
            return USER_GROUPS.AGENCY_GROUP;
        default:
            return role;
    }
};
export default getRoleGroupByRole;